import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar, OptionsObject } from 'notistack';

type INotifications = {
  title: string;
  body: string;
  id: string;
};

let displayed: string[] = [];

const Notifier = () => {
  const dispatch = useDispatch();
  const notifications: INotifications[] = useSelector(
    // @ts-ignore
    store => store.newNotifications.notifications || [],
  );
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (key: string) => {
    displayed = [...displayed, key];
  };

  React.useEffect(() => {
    notifications.forEach(({ title, body, id }) => {
      if (displayed.includes(id)) {
        return;
      }

      const config: OptionsObject = {
        key: id,
        variant: 'info',
      };

      enqueueSnackbar({ title, body }, config);

      storeDisplayed(id);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};

export default Notifier;
